import * as utils from './utils.js';
import * as cart from './cart.js';
import * as mobileNavbar from './mobile-navbar';
import * as mdb from './mdb-pro.js';
import * as printorders from './orders.js';
import * as checkout from './checkout';
import * as formValidation from './form-validation.js';

window.mdb = mdb;
window.toggleSearch = mobileNavbar.toggleSearch;
window.printOrder = printorders.printOrder;

const breakpointSm = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm');
const breakpointMd = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md');
const breakpointLg = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg');
const breakpointXl = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl');
const breakpointXxl = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxl');
const breakpointXxxl = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxl');
const countryCode = document.body.getAttribute('data-country');

jQuery(document).ready(function(){

    // input field only numbers
   jQuery("#cardNumber").keypress(function (e) {
     //if the letter is not digit then display error and don't type anything
     if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
    }
   });

  // FAQ page - open specific tab
  let url = window.location;
  let params = new URLSearchParams(url.search);
  let tab_id = params.get('tab_id');
  let tab_post = params.get('tab_post');

  if (tab_id != null) {
    let faq_list = jQuery("#ewd-ufaq-faq-list").find("#" + tab_id)
    if(faq_list.length > 0){
     jQuery('html, body').animate({
      scrollTop: jQuery('#' + tab_id).offset().top
    }, 2000);

     jQuery('#' + tab_id + '.ewd-ufaq-faq-category-inner .ewd-ufaq-faq-div[data-post_id='+ tab_post +']').addClass('ewd-ufaq-post-active');
     jQuery('#' + tab_id + ' .ewd-ufaq-faq-category-inner .ewd-ufaq-faq-div[data-post_id='+ tab_post +'] .ewd-ufaq-faq-toggle').attr('aria-expanded', true);
     jQuery('#' + tab_id + ' .ewd-ufaq-faq-category-inner .ewd-ufaq-faq-div[data-post_id='+ tab_post +'] .ewd-ufaq-post-margin-symbol span').html('A');
     jQuery('#' + tab_id + ' .ewd-ufaq-faq-category-inner .ewd-ufaq-faq-div[data-post_id='+ tab_post +'] .ewd-ufaq-faq-body').removeClass('ewd-ufaq-hidden').show('aria-expanded', true);
   }
  }

  initToolbarSortBy();
  initToolbarFilter();
  addClicksListenersOnQuantityButtons();
  fixMdbLabelsWhenValueChangeProgrammatically();
  fixMdbLabelsWhenParentWasHidden();
  styleWpcCopyBillingAddressBtn();
  styleWoocommerceAvataxValidateAddressButtons();
  unhideWatermarkLogoWhenSexcelTypeIsSelected();
  updateStockClassForVariableProducts();
  storeInitialValueOfBillingStateBeforeConversionToSelect();
  storeInitialValueOfShippingStateBeforeConversionToSelect();
  checkGrecaptchaReadiness();
  cart.enableUpdateCartButton();
});

jQuery("form.woocommerce-checkout").on('checkout_place_order', function (e) {
  const form = document.querySelector('form[name=checkout]');

  let isFormValid = formValidation.validateForm(form, checkout.getValidationRules(countryCode));

  return isFormValid;
});

jQuery(document.body).on('updated_cart_totals', function () {
  initializeCouponInput();
  addClicksListenersOnQuantityButtons();
  initializeMdbSelects();
  fixMdbLabelsWhenParentWasHidden();
});


jQuery(document.body).on('country_to_state_changed', function () {
  setBillingStateFieldValue();
  setShippingStateFieldValue();
  convertBillingStateFieldToMdb();
  convertShippingStateFieldToMdb();
});

jQuery(document.body).on('applied_coupon_in_checkout removed_coupon_in_checkout', function () {
  utils.reloadPage();
});

jQuery(document.body).on('updated_cart_totals', function () {
  cart.enableUpdateCartButton();
});

jQuery('#mega-menu-item-15420').on('open_panel', function() {
  setTimeout(function() {$('input.search-field').focus();}, 1500);
});

function addClicksListenersOnQuantityButtons () {
  const quantityButtons = jQuery('.quantity-wrapper button[data-input-action');

  if (quantityButtons.length) {
    quantityButtons.each( function() {
      const inputAction = jQuery(this).attr("data-input-action");
      const inputId = jQuery(this).attr("data-input-id");

      if (inputId && inputAction) {
        const inputElement = jQuery("#" + inputId);

        if (inputElement) {
          switch (inputAction) {
            case 'decrement':
              jQuery(this).click(function() {
                inputElement.get(0).stepDown();
                inputElement.trigger("change");
              });
              break;
            case 'increment':
              jQuery(this).click(function() {
                inputElement.get(0).stepUp();
                inputElement.trigger("change");
              });
              break;
          }
        }
      }
    });
  }
}

function initializeCouponInput () {
  document.querySelectorAll('.form-outline.coupon-input').forEach((formOutline) => {
    new mdb.Input(formOutline).init();
  });
}

function initToolbarSortBy () {
  const selectElement = document.getElementsByClassName('select-woocommerce-ordering')[0];
  const labelElement = document.getElementById('labelWoocommerceOrdering');
  const toolbarSortByWrapperId = 'toolbarSortBy';
  const toolbarSortByBtn = document.getElementById('toolbarSortByBtn');

  let labelElementClone;
  let mdbSelect = mdb.Select.getInstance(selectElement);

  if (labelElement) {
    labelElementClone = labelElement.cloneNode(true);
  }

  if (toolbarSortByBtn && selectElement) {
    toolbarSortByBtn.onclick = function () {
      mdbSelect.toggle();
    };

    if (selectElement.value !== 'menu_order') {
      toolbarSortByBtn.dataset.state = 'active';
    }

    selectElement.onchange = function () {
      if (selectElement.value === 'menu_order') {
        delete toolbarSortByBtn.dataset.state;
      } else {
        toolbarSortByBtn.dataset.state = 'active';
      }
    };

    if (window.matchMedia(`(max-width: ${breakpointLg})`).matches) {
      if (mdbSelect) {
        mdbSelect.dispose();

        if (labelElementClone) {
          selectElement.after(labelElementClone);
        }

        mdbSelect = new mdb.Select(selectElement, { container: `#${toolbarSortByWrapperId}`});
      } else {
        mdbSelect = new mdb.Select(selectElement, { container: `#${toolbarSortByWrapperId}`});
      }

    } else {
      if (mdbSelect) {
        mdbSelect.dispose();

        if (labelElementClone) {
          selectElement.after(labelElementClone);
        }

        mdbSelect = new mdb.Select(selectElement);
      } else {
        mdbSelect = new mdb.Select(selectElement);
      }
    }
  }

  window.matchMedia(`(max-width: ${breakpointLg})`).addEventListener('change', initToolbarSortBy, { once: true });
}

function initToolbarFilter () {
  const toolbarFilterBtn = document.getElementById('toolbarFilterBtn');
  const sidebarProductsArchive = document.getElementById('sidebarProductsArchive');
  const areaProductFilters = document.getElementById('sidebarAreaProductFilters');
  const productFiltersModalElement = document.getElementById('productFiltersModal');

  let productFiltersModal;
  let productFiltersModalBodyElement;

  if (productFiltersModalElement && areaProductFilters && sidebarProductsArchive) {
    productFiltersModal = new mdb.Modal(productFiltersModalElement);
    productFiltersModalBodyElement = productFiltersModalElement.getElementsByClassName('modal-body')[0];

    if (window.matchMedia(`(min-width: ${breakpointLg})`).matches) {
      sidebarProductsArchive.prepend(areaProductFilters);
    } else {
      productFiltersModalBodyElement.append(areaProductFilters);
    }
  }

  if (toolbarFilterBtn && productFiltersModal) {
    toolbarFilterBtn.onclick = function () {
      productFiltersModal.toggle();
    };
  }

  window.matchMedia(`(min-width: ${breakpointLg})`).addEventListener('change', initToolbarFilter, { once: true });
}

function initializeMdbSelects() {
  document.querySelectorAll('select.select:not(.select-initialized)').forEach((selectEl) => {
    const mdbSelect = new mdb.Select(selectEl);
  });
}

function convertBillingStateFieldToMdb() {
  const wrapperElement = document.getElementById('billing_state_field');

  if (wrapperElement) {
    const mdbWrapperFound = wrapperElement.querySelector('.form-outline') !== null ? true : false;

    if (! mdbWrapperFound) {
      const labelElement = wrapperElement.querySelector('label');
      const selectElement = document.querySelector('#billing_state');

      if (labelElement && selectElement) {
        if (selectElement.tagName === 'SELECT') {
          const inputWrapper = wrapperElement.querySelector('.woocommerce-input-wrapper');
          const requiredElement = labelElement.querySelector('.required');

          if (inputWrapper) {
            inputWrapper.remove();
          }

          if (requiredElement) {
            if (requiredElement.tagName === 'ABBR') {
              requiredElement.remove();
              const newRequiredElement = document.createElement('span');

              newRequiredElement.classList.add('required');
              newRequiredElement.innerHTML = '*';

              labelElement.append(newRequiredElement);
            }
          }

          labelElement.before(selectElement);
          labelElement.classList.add('form-label');
          labelElement.classList.add('select-label');

          const mdbSelect = new mdb.Select(selectElement, { filter: true });
        }
      }
    }
  }
}

function convertShippingStateFieldToMdb() {
  const wrapperElement = document.getElementById('shipping_state_field');

  if (wrapperElement) {
    const mdbWrapperFound = wrapperElement.querySelector('.form-outline') !== null ? true : false;

    if (! mdbWrapperFound) {
      const labelElement = wrapperElement.querySelector('label');
      const selectElement = document.querySelector('#shipping_state');

      if (labelElement && selectElement) {
        if (selectElement.tagName === 'SELECT') {
          const inputWrapper = wrapperElement.querySelector('.woocommerce-input-wrapper');
          const requiredElement = labelElement.querySelector('.required');

          if (inputWrapper) {
            inputWrapper.remove();
          }

          if (requiredElement) {
            if (requiredElement.tagName === 'ABBR') {
              requiredElement.remove();
              const newRequiredElement = document.createElement('span');

              newRequiredElement.classList.add('required');
              newRequiredElement.innerHTML = '*';

              labelElement.append(newRequiredElement);
            }
          }

          labelElement.before(selectElement);
          labelElement.classList.add('form-label');
          labelElement.classList.add('select-label');

          const mdbSelect = new mdb.Select(selectElement, { filter: true });
        }
      }
    }
  }
}

function fixMdbLabelsWhenValueChangeProgrammatically() {
  let mdbInputs = document.querySelectorAll('input.form-control');

  if (mdbInputs) {
    mdbInputs.forEach(element => {
      observeElement(element, "value", function (oldValue, newValue) {
        if ( oldValue === '' &&  newValue !== '' && !element.classList.contains('active') )
          element.classList.add('active');
      });
    });
  }

  function observeElement(element, property, callback, delay = 0) {
    let elementPrototype = Object.getPrototypeOf(element);

    if (elementPrototype.hasOwnProperty(property)) {
      let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);

      Object.defineProperty(element, property, {
        get: function() {
            return descriptor.get.apply(this, arguments);
        },
        set: function () {
          let oldValue = this[property];
          descriptor.set.apply(this, arguments);
          let newValue = this[property];

          if (typeof callback == 'function') {
              setTimeout(callback.bind(this, oldValue, newValue), delay);
          }

          return newValue;
        }
      });
    }
  }
}

function fixMdbLabelsWhenParentWasHidden() {
  const options = {
    root: document.documentElement,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) { // element is visible
        new mdb.Input(entry.target).update();
      }
    });
  }, options);

  document.querySelectorAll('.form-outline').forEach((formOutline) => {
    observer.observe(formOutline);
  });
}

function styleWpcCopyBillingAddressBtn() {
  const copyBillingAddressBtn = document.querySelector('.wpccb_copy');

  if (copyBillingAddressBtn) {
    copyBillingAddressBtn.classList.add('btn');
    copyBillingAddressBtn.classList.add('btn-primary');
  }
}

function styleWoocommerceAvataxValidateAddressButtons() {
  const validateAddressButtons = document.querySelectorAll('.wc_avatax_validate_address');

  if (validateAddressButtons) {
    validateAddressButtons.forEach(element => {
      element.classList.add('btn');
      element.classList.add('btn-primary');
    });
  }
}

function unhideWatermarkLogoWhenSexcelTypeIsSelected() {
  jQuery( function($){
    $( 'form.variations_form.cart' ).on('show_variation', function(event, data) {
      if (['female-sexcel', 'male-sexcel'].includes(data.attributes["attribute_pa_type-2"])) {
        $('.woocommerce-product-gallery__wrapper').addClass('woocommerce-product-gallery__wrapper--show-sexcel-watermark');
      } else {
        $('.woocommerce-product-gallery__wrapper').removeClass('woocommerce-product-gallery__wrapper--show-sexcel-watermark');
      }
    });

    $( 'form.variations_form.cart' ).on('hide_variation', function() {
      $('.woocommerce-product-gallery__wrapper').removeClass('woocommerce-product-gallery__wrapper--show-sexcel-watermark');
    });
  });
}

function updateStockClassForVariableProducts() {
  jQuery( function($){
    const variableProductContainer = $('.single-product .product.product-type-variable');

    if ( variableProductContainer.length === 1) {
      $( 'form.variations_form.cart' ).on('show_variation', function(event, data) {
        if (data.is_in_stock) {
          variableProductContainer.removeClass('selected-variation-outofstock')
          variableProductContainer.addClass('selected-variation-instock')
        } else {
          variableProductContainer.removeClass('selected-variation-instock')
          variableProductContainer.addClass('selected-variation-outofstock')
        }
      });

      $( 'form.variations_form.cart' ).on('hide_variation', function() {
          variableProductContainer.removeClass('selected-variation-instock')
          variableProductContainer.removeClass('selected-variation-outofstock')
      });
    }
  });
}

// this function is no longer being executed as it was creating more issues
function reloadCheckoutWhenProvinceOrPostcodeChange() {
  const shipToDifferentAddressCheckbox = jQuery('#ship-to-different-address-checkbox');
  const checkoutShippingMethods = jQuery('#checkout-shipping-methods');
  const billingState = jQuery('#billing_state');
  const billingPostcode = jQuery('#billing_postcode');
  const shippingState = jQuery('#shipping_state');
  const shippingPostcode = jQuery('#shipping_postcode');

  const reloadPage = function () { location.reload(); };
  const blockShippingMethods = function () { checkoutShippingMethods.addClass("blocked-ui") };

  billingState.on('change', function() {
    if (shipToDifferentAddressCheckbox.not(':checked').length) {
      blockShippingMethods();

      jQuery(document.body).one('updated_checkout', function() {
        reloadPage();
      });
    }
  });

  billingPostcode.on('change', function() {
    if (shipToDifferentAddressCheckbox.not(':checked').length) {
      blockShippingMethods();

      jQuery(document.body).one('updated_checkout', function() {
        reloadPage();
      });
    }
  });

  shippingState.on('change', function () {
    if (shipToDifferentAddressCheckbox.is(':checked')) {
      blockShippingMethods();

      jQuery(document.body).one('updated_checkout', function() {
        reloadPage();
      });
    }
  });

  shippingPostcode.on('change', function () {
    if (shipToDifferentAddressCheckbox.is(':checked')) {
      blockShippingMethods();

      jQuery(document.body).one('updated_checkout', function() {
        reloadPage();
      });
    }
  });
}

function storeInitialValueOfBillingStateBeforeConversionToSelect() {
  const stateFieldWrapper = document.querySelector('#billing_state_field');
  const stateInput = document.querySelector('input#billing_state');

  if (stateInput && stateFieldWrapper) {
    stateFieldWrapper.dataset.initialValue = stateInput.value;
  }
}

function storeInitialValueOfShippingStateBeforeConversionToSelect() {
  const stateFieldWrapper = document.querySelector('#shipping_state_field');
  const stateInput = document.querySelector('input#shipping_state');

  if (stateInput && stateFieldWrapper) {
    stateFieldWrapper.dataset.initialValue = stateInput.value;
  }
}

function setBillingStateFieldValue() {
  const stateFieldWrapper = document.querySelector('#billing_state_field');
  const select = document.querySelector("select#billing_state");

  if (stateFieldWrapper && select) {
    const stateInitialValue = stateFieldWrapper.dataset.initialValue;

    if (stateInitialValue) {
      for (let i = 0; i < select.options.length; i++) {
        if (select.options[i].text === stateInitialValue) {
          select.selectedIndex = i;
          break;
        }
      }
    }
  }
}

function setShippingStateFieldValue() {
  const stateFieldWrapper = document.querySelector('#shipping_state_field');
  const select = document.querySelector("select#shipping_state");

  if (stateFieldWrapper && select) {
    const stateInitialValue = stateFieldWrapper.dataset.initialValue;

    if (stateInitialValue) {
      for (let i = 0; i < select.options.length; i++) {
        if (select.options[i].text === stateInitialValue) {
          select.selectedIndex = i;
          break;
        }
      }
    }
  }
}

function checkGrecaptchaReadiness() {
  if (typeof grecaptcha == 'object') {
    grecaptcha.ready(function () {
      document.body.classList.add('grecaptcha-ready');
    });
  };
}
